/**
 * Scroll to Messages component
 */
export function scrollToMessages() {
  setTimeout(() => {
    const messagesElement = document.getElementById('errors-container');
    if (messagesElement) {
      messagesElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, 500);
}
